module.exports = __webpack_public_path__ + "img/pic.95d053ab.png";